import script from "./PaperCenter.vue?vue&type=script&setup=true&lang=js"
export * from "./PaperCenter.vue?vue&type=script&setup=true&lang=js"

import "./PaperCenter.vue?vue&type=style&index=0&id=756f80cf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-756f80cf"]])

export default __exports__